export default class ContactAPI {
  constructor(api, version) {
    this.api = api;
    this.version = version;
  }
}